module.exports = __webpack_public_path__ + "media/images/Indicateurs-ba713535801c9250cd43d63a7cd223c2.svg";